module.exports = __webpack_public_path__ + "img/speech-bubble.4aceb733.svg";